window.OKJS = window.OKJS || {};
(function (OKJS) {
  OKJS.Factbox = {
    init: function () {
      var factboxButtons = document.querySelectorAll('.js-show-more-factbox');

      factboxButtons.forEach(function (factboxButton) {
        factboxButton.addEventListener('click', function () {
          var factbox = this.closest('.factbox');

          if (factbox) {
            factbox.classList.toggle('factbox--active');
          }
        });
      });
    },
  };
})(window.OKJS);
